(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewByAssessorRiskController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$mdToast', 'riskSelfAssessmentReviewService',
        'govProcess', 'criterias', 'risksToReview', 'govNotificationDelay', 'assessmentQuestions'];

    function Controller($rootScope, $scope, $state, $stateParams, $mdToast, riskSelfAssessmentReviewService,
                        govProcess, criterias, risksToReview, govNotificationDelay, assessmentQuestions) {

        var riskIndex = _.findIndex(risksToReview, { Risk: { RiskID: $stateParams.RiskID } });
        var risksToReviewCount = risksToReview.length;
        var risksReviewedCount = _.filter(risksToReview, function (risk) {
            if (_.isUndefined(risk.Assessment)) return false;

            return risk.Assessment.HasFinalAssessorReviewed;
        }).length;

        $scope.govProcess = govProcess;
        $scope.risksReviewedCount = risksReviewedCount;
        $scope.risksToReviewCount = risksToReviewCount;
        $scope.riskToReview = risksToReview[riskIndex];

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.isReadOnly = $scope.riskToReview.Assessment && $scope.riskToReview.Assessment.HasFinalAssessorReviewed;
        $scope.ctrlCtxt.criterias = criterias;
        $scope.ctrlCtxt.hasAssessmentQuestions = assessmentQuestions && assessmentQuestions.RiskAssessmentQuestions && assessmentQuestions.RiskAssessmentQuestions.length

        if ($scope.riskToReview.Risk && $scope.riskToReview.Risk.RiskID) {
            riskSelfAssessmentReviewService.getRiskEvents($scope.riskToReview.Risk).then(function (riskEvents) {
                $scope.riskEvents = riskEvents;
                if (riskEvents && riskEvents.length > 0) {
                    $scope.riskEventCssIcon = riskEvents[0].ItemCssIcon;
                }
            });
        }

        initAssessmentIndicators();

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        // Page is not dirty
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Edit risk name and description
        $scope.editRiskNameAndDescription = function () {
            $scope.ctrlCtxt.finalRiskNameBeforeChange =
                $scope.riskToReview.Assessment.FinalRiskNameChange;
            $scope.ctrlCtxt.finalRiskDescriptionBeforeChange =
                $scope.riskToReview.Assessment.FinalRiskDescriptionChange;

            $scope.ctrlCtxt.isEditingRiskNameAndDescription = true;
            $scope.pageIsDirty();
        };

        // Cancel edit risk name and description
        $scope.cancelEditRiskNameAndDescription = function () {
            $scope.riskToReview.Assessment.FinalRiskNameChange =
                $scope.ctrlCtxt.finalRiskNameBeforeChange;
            $scope.riskToReview.Assessment.FinalRiskDescriptionChange =
                $scope.ctrlCtxt.finalRiskDescriptionBeforeChange;

            $scope.ctrlCtxt.isEditingRiskNameAndDescription = false;
        };

        // Edit Final Comment
        $scope.editFinalComment = function () {
            $scope.ctrlCtxt.finalCommentBeforeChange = $scope.riskToReview.Assessment.FinalComments;
            $scope.ctrlCtxt.isEditingFinalComment = true;
            $scope.pageIsDirty();
        };

        // Cancel Edit Final Comment
        $scope.cancelEditFinalComment = function () {
            $scope.riskToReview.Assessment.FinalComments = $scope.ctrlCtxt.finalCommentBeforeChange;
            $scope.ctrlCtxt.isEditingFinalComment = false;
        };

        $scope.isPreviousBtnDisabled = function () {
            return $scope.ctrlCtxt.hasAssessmentQuestions ? false : riskIndex === 0;
        };

        $scope.isNextBtnDisabled = function () {
            return $scope.ctrlCtxt.hasAssessmentQuestions ? false : (riskIndex + 1) === risksToReviewCount;
        };

        // Go to Summary
        $scope.goToSummary = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.summary', {}, { reload: true });
        };

        // Go to Assessors
        $scope.goToAssessors = function () {
            $state.go('riskSelfAssessmentList', {}, { reload: true });
        };

        $scope.goToPreviousPage = function () {
            if ($scope.isPreviousBtnDisabled()) return;

            if (riskIndex === 0 && $scope.ctrlCtxt.hasAssessmentQuestions) {
                // First risk, move to preliminary questions
                $state.go('riskSelfAssessmentReviewByAssessor.preliminaryQuestions');
            } else {
                // Go to previous risk
                var previousRiskIdx = riskIndex - 1;
                $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risksToReview[previousRiskIdx].Risk.RiskID });
            }
        };

        $scope.goToNextPage = function () {
            if ($scope.isNextBtnDisabled()) { return; }

            var nextRiskIdx = riskIndex + 1;
            if (nextRiskIdx === risksToReviewCount) {
                // Button not disabled if last and has assessment questions, safe to go to final
                $state.go('riskSelfAssessmentReviewByAssessor.finalQuestions');
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risksToReview[nextRiskIdx].Risk.RiskID });
            }

        };

        // Go to next risk to review
        $scope.goToNextRiskToReview = function () {
            var risk = _.find(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.HasFinalAssessorReviewed;
            });

            if (!_.isUndefined(risk)) {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risk.Risk.RiskID });
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.finalQuestions');
            }
        };

        // Review and continue
        $scope.reviewAndContinue = function () {
            $scope.ctrlCtxt.isSaving = true;

            if ($scope.isNotAcknowledged()) {
                // Reset IsAccurate
                $scope.riskToReview.Assessment.FinalIsAccurate = null;
                $scope.riskToReview.Assessment.FinalRiskNameChange = null;
                $scope.riskToReview.Assessment.FinalRiskDescriptionChange = null;

                // Reset ratings
                $scope.riskToReview.Assessment.FinalProbabilityCode = null;
                $scope.riskToReview.Assessment.FinalSeverityCode = null;
                $scope.riskToReview.Assessment.FinalMitigationCode = null;
                $scope.riskToReview.Assessment.FinalComputedOverallCode = null;
                $scope.riskToReview.Assessment.FinalOverallCode = null;
                $scope.riskToReview.Assessment.FinalIsOverriden = null;
            }

            if ($scope.hasAssessmentBeenModified()) {
                $scope.riskToReview.Assessment.InitialIndicatorsConfirmedAsIs = false;
            }

            return riskSelfAssessmentReviewService
                .reviewRiskByAssessor($scope.riskToReview)
                .then(function (riskToReview) {
                    _.extend(risksToReview[riskIndex], riskToReview);
                    $scope.ctrlCtxt.isSaving = false;
                    $scope.pageIsNotDirty();
                    $scope.goToNextRiskToReview();
                }, function () {
                    $scope.ctrlCtxt.isSaving = false;
                    if ($scope.isClosing()) {

                        $mdToast.show(
                             $mdToast
                                 .simple()
                                 .content('Some sub risks are not closed.')
                                 .position('top right')
                                 .hideDelay(govNotificationDelay)
                                 .action('OK')
                                 .theme('danger')
                         );
                    }
                });
        };

        // Is review and continue action disabled?
        $scope.isReviewAndContinueActionDisabled = function () {
            if ($scope.ctrlCtxt.isReadOnly) return true;
            if ($scope.form.$invalid) return true;
            if ($scope.ctrlCtxt.isSaving) return true;

            // If Suggested And Not Acknowledged
            if ($scope.askForAcknowledgement() && $scope.isNotAcknowledged()) return !$scope.riskToReview.Assessment.FinalComments;

            // If RecommendClosing And is closing is true => Not disabled
            if ($scope.askForClosing() && $scope.isClosing()) return false;

            // If RecommendClosing And FinalClosing is False with no comments => disabled
            if ($scope.askForClosing() && $scope.isNotClosing() && !$scope.riskToReview.Assessment.FinalComments) {
                return true;
            }

            // Dont ask for acknowledgement and closing and Is Closing with comments
            if (!$scope.askForAcknowledgement() && !$scope.askForClosing() && $scope.isClosing() && $scope.riskToReview.FinalComments) {
                return false;
            }

            // If RecommendClosing And FinalClosing is undefined => disabled
            if ($scope.askForClosing() && _.isUndefined($scope.riskToReview.Assessment.FinalClosing)) {
                return true;
            }

            if ($scope.isClosing() &&
                !$scope.riskToReview.Assessment.FinalComments) {
                return true;
            }

            if ($scope.showAskIsAccurate() && (_.isUndefined($scope.riskToReview.Assessment.FinalIsAccurate) ||
                                               _.isUndefined($scope.riskToReview.Assessment.FinalOverallCode))
                ) {
                return true;
            }
        };

        // Cancel Review
        $scope.cancelReview = function () {
            return riskSelfAssessmentReviewService
                    .cancelReviewRisk($scope.riskToReview)
                    .then(function (riskToReview) {
                        $state.reload();
                    });
        }

        // Have assessement been modified?
        $scope.hasAssessmentBeenModified = function () {
            return $scope.ctrlCtxt.needSaveChanges || $scope.ctrlCtxt.hasAssessmentBeenModified;
        };

        // Ask for Acknowledgement?
        $scope.askForAcknowledgement = function () {
            return $scope.riskToReview.Risk.IsSuggested;
        };

        // Set Acknoweldgement 
        $scope.setAcknowledgement = function (isAcknowledged) {
            if (isAcknowledged === $scope.riskToReview.Assessment.IsAcknowledged) return;

            if (isAcknowledged === false) $scope.riskToReview.Assessment.FinalComments = null;
            $scope.riskToReview.Assessment.IsAcknowledged = isAcknowledged;
            $scope.pageIsDirty();
        };

        // Is not acknowledged?
        $scope.isNotAcknowledged = function () {
            return $scope.riskToReview.Assessment.IsAcknowledged === false;
        };

        // Set proposed closing 
        $scope.setProposedClosing = function (isClosing) {
            $scope.riskToReview.Assessment.FinalClosing = isClosing;
            $scope.pageIsDirty();
        };

        // Ask for Closing?
        $scope.askForClosing = function () {
            return $scope.riskToReview.Risk.RecommendClosing;
        };

        // Is not closing?
        $scope.isNotClosing = function () {
            return $scope.riskToReview.Assessment.FinalClosing === false ||
                   _.isUndefined($scope.riskToReview.Assessment.FinalClosing);
        };

        // Is closing?
        $scope.isClosing = function () {
            return $scope.riskToReview.Assessment.FinalClosing === true;
        };

        // Show ask is accurate
        $scope.showAskIsAccurate = function () {
            if ($scope.askForAcknowledgement() && $scope.isNotAcknowledged()) return false;

            return $scope.isNotClosing();
        };

        // Set Is Accurate to true
        $scope.setIsAccurateToTrue = function () {
            $scope.riskToReview.Assessment.FinalIsAccurate = true;
            $scope.riskToReview.Assessment.FinalRiskNameChange = null;
            $scope.riskToReview.Assessment.FinalRiskDescriptionChange = null;
            $scope.pageIsDirty();
        };

        // Set Is Accurate to false
        $scope.setIsAccurateToFalse = function () {
            $scope.riskToReview.Assessment.FinalIsAccurate = false;
            $scope.riskToReview.Assessment.FinalRiskNameChange =
                    $scope.riskToReview.Assessment.PriorPeriodRiskName;
            $scope.riskToReview.Assessment.FinalRiskDescriptionChange =
                    $scope.riskToReview.Assessment.PriorPeriodRiskDescription;
            $scope.pageIsDirty();
        };

        // Show name and description changes
        $scope.showNameAndDescriptionChanges = function () {
            if (!$scope.showAskIsAccurate()) return false;

            return $scope.riskToReview.Assessment.FinalIsAccurate === false;
        };

        // Show Ratings?
        $scope.showRatings = function () {
            return $scope.showAskIsAccurate();
        }

        // Show final name and description?
        $scope.showFinalNameAndDescription = function () {
            if ($scope.isNotClosing() && $scope.riskToReview.Assessment.InitialProposedClosing === true) return true;

            return !$scope.ctrlCtxt.isEditingRiskNameAndDescription &&
                    $scope.areRiskAndDescriptionChangesDifferent();
        };

        // Are risk and description changes different?
        $scope.areRiskAndDescriptionChangesDifferent = function () {
            return ($scope.riskToReview.Assessment.FinalRiskNameChange !==
                        $scope.riskToReview.Assessment.InitialProposedRiskNameChange ||
                    $scope.riskToReview.Assessment.FinalRiskDescriptionChange !==
                        $scope.riskToReview.Assessment.InitialProposedRiskDescriptionChange);
        };

        // Helpers
        function getSelectedRating(ratingCode, ratings) {
            return _.find(ratings, { Code: ratingCode });
        }

        function initAssessmentIndicators() {
            if ($scope.riskToReview.Assessment.InitialIndicatorsConfirmedAsIs === false) return;

            $scope.riskToReview.Assessment.FinalClosing =
                    $scope.riskToReview.Assessment.InitialProposedClosing;

            $scope.riskToReview.Assessment.FinalIsAccurate =
                    $scope.riskToReview.Assessment.InitialIsAccurate;

            $scope.riskToReview.Assessment.FinalRiskNameChange =
                $scope.riskToReview.Assessment.InitialProposedRiskNameChange;

            $scope.riskToReview.Assessment.FinalRiskDescriptionChange =
                    $scope.riskToReview.Assessment.InitialProposedRiskDescriptionChange;
        }

    }
})();
